const giveTextColor = (color) => {
  switch (color) {
    case "red":
      return "red";
    case "green":
      return "#107c41";
    case "orange":
      return "#fea25a";
    case "black":
      return "#000";
    case "purple":
      return "#7c1eaf";
    case "yellow":
      return "#f0e130";
    case "gray":
      return "#808080";
    case "pink":
      return "#ff69b4";
    case "violet":
      return "#8a2be2";
    case "blue":
      return "#0000ff";
    case "cyan":
      return "#00ffff";
    case "teal":
      return "#008080";
    case "navy":
      return "#000080";
    case "gold":
      return "#ffd700";
    case "silver":
      return "#c0c0c0";
    case "brown":
      return "#a52a2a";
    case "magenta":
      return "#ff00ff";
    case "olive":
      return "#808000";
    case "lime":
      return "#00ff00";
    case "maroon":
      return "#800000";
    case "salmon":
      return "#fa8072";
    case "skyblue":
      return "#87ceeb";
    case "lavender":
      return "#e6e6fa";
    case "indigo":
      return "#4b0082";
    case "peach":
      return "#ffe5b4";
    case "orchid":
      return "#da70d6";
    case "crimson":
      return "#dc143c";
    case "coral":
      return "#ff7f50";
    case "darkgreen":
      return "#006400";
    case "darkblue":
      return "#00008b";
    case "darkred":
      return "#8b0000";
    case "darkorange":
      return "#ff8c00";
    case "darkcyan":
      return "#008b8b";
    case "darkviolet":
      return "#9400d3";
    case "darkgray":
      return "#a9a9a9";
    case "lightblue":
      return "#add8e6";
    case "lightgreen":
      return "#90ee90";
    case "lightyellow":
      return "#ffffe0";
    case "lightgray":
      return "#d3d3d3";
    case "darkslategray":
      return "#2f4f4f";
    case "rosybrown":
      return "#bc8f8f";
    case "sienna":
      return "#a0522d";
    case "tan":
      return "#d2b48c";
    case "wheat":
      return "#f5deb3";
    case "khaki":
      return "#f0e68c";
    case "turquoise":
      return "#40e0d0";
    case "aquamarine":
      return "#7fffd4";
    case "mediumblue":
      return "#0000cd";
    case "mediumorchid":
      return "#ba55d3";
    case "mediumpurple":
      return "#9370db";
    case "mediumseagreen":
      return "#3cb371";
    case "mediumslateblue":
      return "#7b68ee";
    case "mediumspringgreen":
      return "#00fa9a";
    case "mediumturquoise":
      return "#48d1cc";
    case "mediumvioletred":
      return "#c71585";
    case "midnightblue":
      return "#191970";
    case "navajowhite":
      return "#ffdead";
    case "oldlace":
      return "#fdf5e6";
    case "orangered":
      return "#ff4500";
    case "palegoldenrod":
      return "#eee8aa";
    case "palegreen":
      return "#98fb98";
    case "paleturquoise":
      return "#afeeee";
    case "palevioletred":
      return "#db7093";
    case "papayawhip":
      return "#ffefd5";
    case "peachpuff":
      return "#ffdab9";
    case "peru":
      return "#cd853f";
    case "plum":
      return "#dda0dd";
    case "powderblue":
      return "#b0e0e6";
    case "royalblue":
      return "#4169e1";
    case "saddlebrown":
      return "#8b4513";
    case "sandybrown":
      return "#f4a460";
    case "seagreen":
      return "#2e8b57";
    case "seashell":
      return "#fff5ee";
    case "slateblue":
      return "#6a5acd";
    case "slategray":
      return "#708090";
    case "springgreen":
      return "#00ff7f";
    case "steelblue":
      return "#4682b4";
    case "thistle":
      return "#d8bfd8";
    case "tomato":
      return "#ff6347";
    case "whitesmoke":
      return "#f5f5f5";
    case "yellowgreen":
      return "#9acd32";
    default:
      return "#000";
  }
};

export { giveTextColor };
